export interface UserLabelSource {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
}

function normalizePart(value?: string | null): string {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
}

export function formatUserLabel(source?: UserLabelSource | null, fallback = ''): string {
  const firstname = normalizePart(source?.firstname);
  const lastname = normalizePart(source?.lastname);
  const email = normalizePart(source?.email);

  if (firstname && lastname) {
    return `${firstname} ${lastname}`;
  }

  if (firstname || lastname) {
    const partialName = firstname || lastname;
    return email ? `${partialName} (${email})` : partialName;
  }

  return email || fallback;
}
